import { useTranslation } from 'react-i18next';
import { Button } from '@material-ui/core';
import { useStyles } from './styles';

interface SaveSearchButtonProps {
  isSearchSaved: boolean;
  onClick?: () => void;
}

export default function SaveSearchButton({
  isSearchSaved,
  onClick,
}: SaveSearchButtonProps): JSX.Element {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Button
      aria-label="save-search-button"
      className={classes.saveSearchButton}
      disabled={isSearchSaved}
      onClick={onClick}
    >
      {isSearchSaved ? t('srp.filters.searchSaved') : t('srp.filters.saveSearch')}
    </Button>
  );
}
